import type { ReactNode } from 'react';

/**
 * The head of a Health & readiness detail pane (prototype `.hr-detail
 * .head`): the pane title with an optional chip, one meta line under it,
 * and the pane's actions on the right. Every pane uses it so the four
 * read as one screen.
 */
export function PaneHeader({
  title,
  chip,
  meta,
  actions,
}: {
  title: string;
  chip?: ReactNode;
  meta?: ReactNode;
  actions?: ReactNode;
}) {
  return (
    <header className="flex flex-wrap items-start justify-between gap-4">
      <div className="min-w-0">
        <h2 className="t-h1 flex flex-wrap items-center gap-2 text-ink-900">
          {title}
          {chip}
        </h2>
        {meta ? <div className="t-meta mt-0.5">{meta}</div> : null}
      </div>
      {actions ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
    </header>
  );
}

/** `status_report` → `Status report`; the API vocabularies are snake_case. */
export function humanize(value: string): string {
  const spaced = value.replace(/[_-]+/g, ' ').trim();
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}
